import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../AuthContext';

export default function SetupPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('הסיסמאות אינן תואמות');
      return;
    }
    if (password.length < 8) {
      setError('הסיסמה חייבת להכיל לפחות 8 תווים');
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post('/auth/setup-password', { token, password });
      login(data.access_token, data.user);
      navigate(data.user.org_layer === 'admin' ? '/admin' : '/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.detail || 'שגיאה בהגדרת הסיסמה');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <h2>קישור לא תקין</h2>
          <p className="text-muted" style={{ marginTop: '8px' }}>אנא פנה למנהל המערכת</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-screen">
      <div className="card auth-card">
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <img src="/logo_rashut.png" alt="רשות הצעירים של ירושלים" className="auth-logo" />
          <div className="auth-title">
            ברוך הבא
          </div>
          <div className="text-muted">הגדר סיסמה לחשבונך</div>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">סיסמה חדשה</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="לפחות 8 תווים"
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">אימות סיסמה</label>
            <input
              type="password"
              className="form-input"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              placeholder="חזור על הסיסמה"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%', marginTop: '8px' }} disabled={loading}>
            {loading ? 'שומר...' : 'הגדר סיסמה והתחבר'}
          </button>
        </form>
      </div>
    </div>
  );
}
